// The product flows — one per sidebar section. Mirrors the Go constants
// in internal/shared/auth/flows.go; keys must stay in sync.
export type Flow =
  'sales' | 'inventory' | 'storage' | 'service' | 'inspection' | 'finance' | 'reports' | 'marketing'

export const FLOWS: { key: Flow; label: string }[] = [
  { key: 'sales', label: 'Sales' },
  { key: 'inventory', label: 'Inventory' },
  { key: 'storage', label: 'Storage' },
  { key: 'service', label: 'Service' },
  { key: 'inspection', label: 'Inspection' },
  { key: 'finance', label: 'Finance' },
  { key: 'reports', label: 'Reports' },
  { key: 'marketing', label: 'Marketing' },
]

export function flowLabel(flow: Flow): string {
  return FLOWS.find((f) => f.key === flow)?.label ?? flow
}

// Route for each flow's main page — used by nav links, the sidebar logo, and
// the route guards' fallback landing route.
export const FLOW_ROUTES: Record<Flow, string> = {
  sales: '/sales',
  inventory: '/inventory',
  storage: '/storage',
  service: '/service',
  inspection: '/inspection',
  finance: '/finance',
  reports: '/reports',
  marketing: '/marketing',
}
